module.exports = __webpack_public_path__ + "img/koishi komeiji_sc1.3db9ab3f.png";